import preloadedMessages from "@/lang/translations/en.json";

export default {
  en: {
    name: "English",
    messages: preloadedMessages
  },
  es: {
    name: "Español",
    load: () => {
      return import("@/lang/translations/es.json");
    }
  }
};

